const activityEvents: string[] = ['mousedown', 'mousemove', 'keydown', 'scroll', 'touchstart'];

/**
 * Represents an activity detector that tracks user activity and determines if the current browser
 * tab is inactive.
 */
export class ActivityDetector {
  private lastActivityTimestamp: number;
  private readonly inactiveThresholdInSecond: number;

  /**
   * Creates an instance of ActivityDetector.
   *
   * @param inactiveThresholdInSecond - The threshold in seconds to consider the browser tab as
   *   inactive.
   */
  constructor(inactiveThresholdInSecond: number) {
    this.lastActivityTimestamp = Date.now();
    this.inactiveThresholdInSecond = inactiveThresholdInSecond;
    this.registerListeners();
  }

  destroy = (): void => {
    activityEvents.forEach((eventName): void => {
      document.removeEventListener(eventName, this.onActivity, true);
    });
  };

  /** Callback when user has any activity */
  onActivity = (): void => {
    // reset the timer
    this.lastActivityTimestamp = Date.now();
  };

  /** Register all DOM events listeners tied to user activity */
  registerListeners = (): void => {
    activityEvents.forEach((eventName): void => {
      document.addEventListener(eventName, this.onActivity, true);
    });
  };

  /** Return seconds since last activity. */
  getSecondsSinceLastActivity = (): number =>
    Math.round((Date.now() - this.lastActivityTimestamp) / 1000);

  /** Whether current browser tab is inactive. */
  getIsActive = (): boolean => this.getSecondsSinceLastActivity() < this.inactiveThresholdInSecond;
}
